import type { DefaultComponentProps } from "@/types/component.types";
import cn from "@/utils/cn";
import styles from "./Divider.module.css";

export interface DividerProps extends DefaultComponentProps {
    readonly borderColor?: "subtle";
}

function Divider({ borderColor, className }: DividerProps) {
    return (
        <hr
            className={cn(
                styles.hr,
                borderColor && styles[borderColor],
                className
            )}
        />
    );
}

export default Divider;
